import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { CheckoutForm,stripePromise } from './StripeComponents';
 
const PaymentModal = ({ 
  showStripe, 
  language,
  displayLanguage,
  setShowStripe, 
  processing, 
  setProcessing, 
  clientSecret, 
  onSuccess, 
  onCancel,
  setPaymentData,
  paymentAmount,
  currency,
  currencySymbol,
  translations = {
    completePayment: 'Complete Payment',
    processing: 'Processing...',
    cancel: 'Cancel',
    pay: 'Pay'
  }
}) => {
  if (!showStripe || !clientSecret) return null;
  return (
    <div className="modal" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{translations.completePayment}</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onCancel}
              disabled={processing}
            />
          </div>
          <div className="modal-body">
            <Elements
              stripe={stripePromise}
              options={{
                clientSecret,
                appearance: { theme: 'stripe' }
              }}
            >
              <CheckoutForm
                onSuccess={onSuccess}
                setPaymentData={setPaymentData}
                onClose={onCancel}
                processing={processing}
                setProcessing={setProcessing}
                amount={paymentAmount}
                clientSecret={clientSecret}
                currency={currency}
                currencySymbol={currencySymbol}
                translations={translations}
                language={language}
                displayLanguage={displayLanguage}
              />
            </Elements>
          </div>
        </div>
      </div>
    </div>
  );
};
 
export default PaymentModal;

// import React from 'react';
// import { Elements } from '@stripe/react-stripe-js';
// import { CheckoutForm,stripePromise } from './StripeComponents';

// const PaymentModal = ({ 
//   showStripe, 
//   setShowStripe, 
//   processing, 
//   setProcessing, 
//   clientSecret, 
//   onSuccess, 
//   setPaymentData,
//   paymentAmount 
// }) => {
//   if (!showStripe || !clientSecret) return null;

//   return (
//     <div className="modal" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
//       <div className="modal-dialog modal-dialog-centered">
//         <div className="modal-content">
//           <div className="modal-header">
//             <h5 className="modal-title">Complete Payment</h5>
//             <button
//               type="button"
//               className="btn-close"
//               onClick={() => setShowStripe(false)}
//               disabled={processing}
//             />
//           </div>
//           <div className="modal-body">
//             <Elements
//               stripe={stripePromise}
//               options={{
//                 clientSecret,
//                 appearance: { theme: 'stripe' }
//               }}
//             >
//               <CheckoutForm
//                 onSuccess={onSuccess}
//                 setPaymentData={setPaymentData}
//                 onClose={() => setShowStripe(false)}
//                 processing={processing}
//                 setProcessing={setProcessing}
//                 amount={paymentAmount}
//                 clientSecret={clientSecret}
//               />
//             </Elements>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PaymentModal;